import { useCheckboxState } from '../abstract/checkbox';

export function useReducedFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: reduced, setChecked: onReducedChange } = useCheckboxState({
    defaultValue: query.reduced,
    filterKey: `reduced`,
    setFilters,
    updateQuery,
  });

  return { reduced, onReducedChange };
}
